const CalledFromEnum = {
  Agenda: 'agenda',
  Totem: 'totem',
  NowServing: 'now-serving',
  VirtualineAgenda: 'virtualine-agenda',
  Reception: 'reception',
}

module.exports = {
  CalledFromEnum,
}